import React from 'react';
import { Link } from 'react-router-dom';
import { Award, ShieldCheck, Leaf, Shield, ClipboardCheck, ArrowRight, CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import { services } from '../data/mock';

const Services = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const quotePath = language === 'en' ? '/quote' : '/preventivo';
  const contactPath = language === 'en' ? '/contact' : '/contatti';

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">{t.services.title}</h1>
          <p className="page-subtitle">
            {t.services.subtitle}
          </p>
        </div>
      </section>

      {/* Services Detail Section */}
      <section className="services-detail-section">
        {services.map((service, index) => (
          <div key={service.id} className={`service-detail-card ${index % 2 === 1 ? 'reverse' : ''}`}>
            <div className="service-detail-icon">
              {service.icon === 'award' && <Award size={48} />}
              {service.icon === 'shield-check' && <ShieldCheck size={48} />}
              {service.icon === 'leaf' && <Leaf size={48} />}
              {service.icon === 'shield' && <Shield size={48} />}
              {service.icon === 'clipboard-check' && <ClipboardCheck size={48} />}
            </div>
            <div className="service-detail-content">
              <h2 className="service-detail-title">{service.title}</h2>
              <h3 className="service-detail-subtitle">
                {language === 'en' ? service.subtitleEn : service.subtitle}
              </h3>
              <p className="service-detail-description">
                {language === 'en' ? service.descriptionEn : service.description}
              </p>
              <div className="service-detail-benefits">
                <h4 className="benefits-title">
                  {language === 'en' ? 'Key Benefits:' : 'Vantaggi Principali:'}
                </h4>
                <ul className="benefits-list">
                  {(language === 'en' ? service.benefitsEn : service.benefits).map((benefit, idx) => (
                    <li key={idx}>
                      <CheckCircle size={20} />
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="section-header">
          <h2 className="section-title">{t.services.processTitle}</h2>
          <p className="section-description">
            {t.services.processSubtitle}
          </p>
        </div>
        <div className="process-steps">
          {t.services.steps.map((step, idx) => (
            <div key={idx} className="process-step">
              <div className="step-number">{String(idx + 1).padStart(2, '0')}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section-small">
        <div className="cta-content">
          <h2 className="cta-title">{t.services.ctaTitle}</h2>
          <p className="cta-description">
            {t.services.ctaSubtitle}
          </p>
          <div className="cta-buttons">
            <Link to={quotePath} className="btn-primary">
              {t.common.requestQuote}
              <ArrowRight size={20} />
            </Link>
            <Link to={contactPath} className="btn-secondary">
              {t.common.contactUs}
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
